export default "__VITE_ASSET__NKzzrYzA__"